function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.MagicGrid = e();
}(this, function () {
  "use strict";

  var t = function t(_t) {
    if (!_t) throw new Error("No config object has been provided.");
    "boolean" != typeof _t.useTransform && (_t.useTransform = !0), "number" != typeof _t.gutter && (_t.gutter = 25), _t.container || e("container"), _t.items || _t.static || e("items or static");
  },
      e = function e(t) {
    throw new Error("Missing property '" + t + "' in MagicGrid config");
  },
      i = function i(t) {
    var e = t[0];

    var _iterator = _createForOfIteratorHelper(t),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var i = _step.value;
        i.height < e.height && (e = i);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return e;
  },
      n = function n(e) {
    t(e), e.container instanceof HTMLElement ? (this.container = e.container, this.containerClass = e.container.className) : (this.containerClass = e.container, this.container = document.querySelector(e.container)), this.items = this.container.children, this.static = e.static || !1, this.size = e.items, this.gutter = e.gutter, this.maxColumns = e.maxColumns || !1, this.useMin = e.useMin || !1, this.useTransform = e.useTransform, this.animate = e.animate || !1, this.started = !1, this.init();
  };

  return n.prototype.init = function () {
    if (this.ready() && !this.started) {
      this.container.style.position = "relative";

      for (var t = 0; t < this.items.length; t++) {
        var e = this.items[t].style;
        e.position = "absolute", this.animate && (e.transition = (this.useTransform ? "transform" : "top, left") + " 0.2s ease");
      }

      this.started = !0;
    }
  }, n.prototype.colWidth = function () {
    return this.items[0].getBoundingClientRect().width + this.gutter;
  }, n.prototype.setup = function () {
    var t = this.container.getBoundingClientRect().width,
        e = this.colWidth(),
        i = Math.floor(t / e) || 1,
        n = [];
    this.maxColumns && i > this.maxColumns && (i = this.maxColumns);

    for (var s = 0; s < i; s++) {
      n[s] = {
        height: 0,
        index: s
      };
    }

    return {
      cols: n,
      wSpace: t - i * e + this.gutter
    };
  }, n.prototype.nextCol = function (t, e) {
    return this.useMin ? i(t) : t[e % t.length];
  }, n.prototype.positionItems = function () {
    var t = this.setup(),
        e = t.cols,
        i = t.wSpace,
        n = 0,
        s = this.colWidth();
    i = Math.floor(i / 2);

    for (var o = 0; o < this.items.length; o++) {
      var r = this.nextCol(e, o),
          a = this.items[o],
          h = r.height ? this.gutter : 0,
          c = r.index * s + i + "px",
          u = r.height + h + "px";
      this.useTransform ? a.style.transform = "translate(" + c + ", " + u + ")" : (a.style.top = u, a.style.left = c), r.height += a.getBoundingClientRect().height + h, r.height > n && (n = r.height);
    }

    this.container.style.height = n + "px";
  }, n.prototype.ready = function () {
    return !!this.static || this.items.length >= this.size;
  }, n.prototype.getReady = function () {
    var t = this,
        e = setInterval(function () {
      t.container = document.querySelector(t.containerClass), t.items = t.container.children, t.ready() && (clearInterval(e), t.init(), t.listen());
    }, 100);
  }, n.prototype.listen = function () {
    var t = this;

    if (this.ready()) {
      var e;
      window.addEventListener("resize", function () {
        e || (e = setTimeout(function () {
          t.positionItems(), e = null;
        }, 200));
      }), this.positionItems();
    } else this.getReady();
  }, n;
});